import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import rootStore from '@/app/store'
import { useNewChat } from './useNewChat'

/**
 * Hook para manejar los atajos de teclado globales de la sidebar
 *
 * Atajos implementados:
 * - Ctrl/Cmd + I: Nuevo chat
 * - Ctrl/Cmd + H: Ir al historial
 *
 * @example
 * ```tsx
 * export const Sidebar = () => {
 *   useKeyboardShortcuts()
 *   return <div>...</div>
 * }
 * ```
 */
export const useKeyboardShortcuts = () => {
  const navigate = useNavigate()
  const handleNewChat = useNewChat()

  useEffect(() => {
    const { keybindings } = rootStore

    // Handler para ir al historial (Ctrl/Meta + H)
    const handleGoToHistory = () => {
      navigate('/history')
    }

    // Registrar shortcuts
    const newChatRegistry = keybindings.register({
      keys: ['ctrl+i', 'meta+i'],
      callback: handleNewChat,
    })

    const historyRegistry = keybindings.register({
      keys: ['ctrl+h', 'meta+h'],
      callback: handleGoToHistory,
    })

    // Cleanup: desregistrar shortcuts al desmontar
    return () => {
      keybindings.unregister(newChatRegistry)
      keybindings.unregister(historyRegistry)
    }
  }, [navigate, handleNewChat])
}
